import { render, staticRenderFns } from "./PassportCznIndicatorEditButton.vue?vue&type=template&id=271ea67e"
import script from "./PassportCznIndicatorEditButton.vue?vue&type=script&lang=js"
export * from "./PassportCznIndicatorEditButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports